import { LOGOUT_REQUEST } from '@sit/client-shared';
import { handleActions } from 'redux-actions';
import { SimpleAction } from '../../types/redux/actions';
import { ClusterAssignModalStore, SelectedValues } from '../../types/redux/stores/clusterAssignModal.types';
import * as actionDefinitions from './actionDefinitions';

const initialState: ClusterAssignModalStore = {
  cluster: {},
  item: {},
  visible: false,
  values: null,
  selectedValues: {},
};

const showClusterAssignModal = (state: ClusterAssignModalStore, action: SimpleAction) => {
  return {
    ...state,
    visible: true,
    cluster: action.payload.cluster,
    item: action.payload.item,
    values: action.payload.values || null,
  };
};
const hideClusterAssignModal = () => {
  return initialState;
};

const setClusterAssignModalSelectedValues = (state: ClusterAssignModalStore, action: SimpleAction<SelectedValues>) => {
  return {
    ...state,
    selectedValues: {
      ...state.selectedValues,
      ...action.payload,
    },
  };
};

const logoutRequest = () => initialState;

export default handleActions(
  {
    [actionDefinitions.SHOW_CLUSTER_MODAL]: showClusterAssignModal,
    [actionDefinitions.HIDE_CLUSTER_MODAL]: hideClusterAssignModal,
    [actionDefinitions.SET_CLUSTER_ASSIGN_MODAL_SELECTED_VALUES]: setClusterAssignModalSelectedValues,
    [LOGOUT_REQUEST]: logoutRequest,
  },
  initialState,
);
